import { useDispatch } from "react-redux";
import React, { useCallback, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "./HACReport.css";

import ReportTable from "../ReportTable";
import HACReportFilter from "./HACReportFilter";
import { useReport } from "../hooks/useReport";
import { batchUpdateAppliedFilters } from "../redux/ReportsSlice";

import totalOutstanding from "../../../../common/assets/images/notification-box.png";
import highPriority from "../../../../common/assets/images/highPriority.png";
import calendar from "../../../../common/assets/images/calendar.png";
import hourglass from "../../../../common/assets/images/hourglass.png";
// import { exportReportData } from "../redux/ReportsSlice";
import { getReportConfig } from "../optionsConfig";
import { useSelector } from "react-redux";

const REPORT_PATH = "/hac-report";
const reportAPIConfig = getReportConfig(REPORT_PATH);

const HACReport = () => {
  const dispatch = useDispatch();
  const appliedFilters = useSelector(
    (s) => s.reports.appliedFilters[REPORT_PATH] || {},

  );
  const {
    episodes,
    reportData,
    totalPages,
    pageNumber,
    setPageNumber,
    searchText,
    setSearchText,
    handleSearchChange,
    reportLoading,
    reportError,
    exportLoading,
    // handleExport,
    handleReset,
    resetSignal,
    setSortPayload,
  } = useReport(REPORT_PATH);

  const [sortPayload, setSortPayloadState] = useState({});
  // ✅ Added handleColumnFilterApply — was missing entirely in original
  const handleColumnFilterApply = useCallback(
    (filters) => {
      dispatch(
        batchUpdateAppliedFilters({
          reportPath: REPORT_PATH,
          filters,
        }),
      );
      setPageNumber(1);
    },
    [dispatch, setPageNumber],
  );


  return (
    <div className="hac-report-table-container mt-3 px-2" style={{ flexShrink: 0 }}>
      <h4 className="pb-2">Hospital Acquired Complications (HACs) Report</h4>

      {/* ── Widget cards ── */}
      {/* <div className="d-flex gap-2 mb-3 flex-wrap">
        {widgets.map((w) => (
          <div
            key={w.label}
            className="outstanding-widget col"
            style={{ background: w.bgColor }}>
            <div>
              <p className="mb-1">{w.label}</p>
              {reportLoading ? (
                <Skeleton width={60} />
              ) : (
                <p className="mb-0 fw-bold">{w.count ?? "0"}</p>
              )}
            </div>
            <div>
              <img src={w.icon} alt={w.label} />
            </div>
          </div>
        ))}
      </div> */}

      <ReportTable
        key="hac"
        episodes={episodes}
        isReportLoading={reportLoading}
        isReportError={reportError}
        reportPageNumber={pageNumber}
        setReportPageNumber={setPageNumber}
        // handleReportExport={handleExport}
        reportExcelLoading={exportLoading}
        handleSearchChange={handleSearchChange}
        totalPages={totalPages}
        searchText={searchText}
        setSearchText={setSearchText}
        onSortChange={setSortPayload}
        onReset={handleReset}
        resetSignal={resetSignal}
        onColumnFilterApply={handleColumnFilterApply}
      />

      <HACReportFilter onFiltersApplied={() => setPageNumber(1)} />
    </div>
  );
};

export default HACReport;
